// removed by extract-text-webpack-plugin
module.exports = {"body":"body___1Rfbn","links":"links___31WXV","submit":"submit___3jzX8","modalTerms":"modalTerms___150oy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/SignUpModal/SignUpEmail.scss
// module id = Pb0h
// module chunks = 60